module.exports = __webpack_public_path__ + "static/media/IP_Agent_Portal.875732d8.png";